import { html, TemplateElement, i18n } from '@webtides/element-js';
import SpecFilterEvents from './SpecFilterEvents';
import styles from './_SpecFilter.css';
import '../../../../legacy-library/webcomponents/svg-icon/svg-icon';

export default class SpecFilter extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [styles] });
    }

    properties() {
        return {
            key: '',
            multiple: true,
            //spec values
            values: [],
            meta: {},
            //selected value indices
            selected: -1,
            //disabled value indices
            disabled: [],
            //
            link: {},
            showBtnLabel: i18n('cta.filter.show.label', 'Anzeigen'),
            filterButtonIcon: false,
            filterButtonType: 'btn-brand',
        };
    }

    connected() {
        this.updateDisabled();
    }
    beforeUpdate() {
        this.updateDisabled();
    }

    updateDisabled() {
        this.disabled = this.values
            .map((val, index) => (val.enabled === false ? index : null))
            .filter(entry => entry !== null);
    }

    events() {
        return {
            'button[ref=showBtn]': {
                click: e => {
                    const { key, values } = this;
                    this.dispatch(SpecFilterEvents.APPLY_SINGLE_FILTER, { key, values }, true);
                },
            },
        };
    }

    changeSelection(index) {
        if (!index) {
            return null;
        }
        this.values[index].selected = !this.values[index].selected;
        //cache timestamp to render chips in selection order
        this.values[index].selectedTime = Date.now();

        if (!this.multiple && this.values[index].selected) {
            this.values.forEach((value, valueIndex) => {
                value.selected = parseInt(index) === valueIndex;
            });
        }
        this.requestUpdate();
        this.selected = index;

        this.dispatch(SpecFilterEvents.FILTER_CHANGE, { [this.key]: this.values }, true);
    }

    renderValues() {
        return values.join(',');
    }

    template() {
        return html`
            <div class="spec-filter flex flex-col justify-between py-4 cursor-default">
                <div class="values text-left px-4 flex-grow">${this.renderValues()}</div>
                <div class="px-4">
                    <button
                        ref="showBtn"
                        class="btn ${this.filterButtonType} hidden lg:flex flex-shrink-0 w-full mt-6 mb-1"
                    >
                        <span>${this.showBtnLabel}</span>
                        ${this.filterButtonIcon ? this.filterButtonIcon : ''}
                    </button>
                    ${this.link
                        ? html`
                              <div class="flex-shrink-0 text-center text-sm underline mt-2 normal-case">
                                  <a href="${this.link.url}" target="_blank">${this.link.label}</a>
                              </div>
                          `
                        : ''}
                </div>
            </div>
        `;
    }
}
